import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const AboutUs = () => {
  const { t } = useTranslation();
  const why_resay_list = t("aboutpage.why_resay_list", { returnObjects: true });

  return (
    <React.Fragment>
      <div className="content-box about">
        <div className="aboutbox">
          <h2 className="page_title">{t('about_resay')}</h2>
          <div className="formatted">
            <h4 className="">{t("aboutpage.in_short")}</h4>
            <p>{t("aboutpage.ruletitle")}</p>
            <p className="margin_left_50px">
              {t("aboutpage.participent_title")}
            </p>
            <p className="margin_left_50px">
              {t("aboutpage.from_nathaniel_tech")}
            </p>
            <p>{t("aboutpage.statement")}</p>
            <h4>{t("aboutpage.why_resay_title")}</h4>
            <p>{t("aboutpage.why_resay_subtitle")}</p>
            <ol>
              {why_resay_list.map((p, i) => (
                <li key={i}>{p}</li>
              ))}
            </ol>
            <p>{t("aboutpage.difficult_conversation_description")}</p>
            <p>{t("aboutpage.good_definition")}</p>
            <h4>{t("aboutpage.how_it_works")}</h4>
            <p>{t("aboutpage.rules_title")}</p>
            <ol>
              <li>{t("aboutpage.rule_1")}</li>
              <li> {t("aboutpage.rule_2")}</li>
              <li>
                {t("aboutpage.rule_3")}
                <ol className="alpha">
                  <li>{t("aboutpage.subrule_1")}</li>
                  <li>{t("aboutpage.subrule_2")}</li>
                </ol>
              </li>
              <li>{t("aboutpage.rule_4")}</li>
              <li>{t("aboutpage.rule_5")}</li>
              <li>{t("aboutpage.rule_6")}</li>
              <li>{t("aboutpage.rule_7")}
                <ol className="alpha">
                  <li>{t("aboutpage.subrule_3")}</li>
                  <li>{t("aboutpage.subrule_4")}</li>
                </ol>
              </li>
              <li>{t("aboutpage.rule_8")}</li>
            </ol>
            <p>
              {t("aboutpage.end_of_game")}
            </p>
            <h4>{t("aboutpage.improvements_title")}</h4>
            <ol>
              <li>
                {t("aboutpage.improvement_1")}
              </li>
              <li>
                {t("aboutpage.improvement_2")}
                <ol>
                  <li>
                    {t("aboutpage.gamification_1")}
                  </li>
                  <li>
                    <Trans
                      i18nKey="aboutpage.gamification_2"
                      values={{ link: "https://en.wikipedia.org/wiki/Likert_scale" }}
                      components={{
                        linktag: <Link target="_blank" to="https://en.wikipedia.org/wiki/Likert_scale">Link</Link>
                      }}
                    />
                  </li>
                </ol>
              </li>
              <li>
                {t("aboutpage.improvement_3")}
              </li>
              <li>
                {t("aboutpage.improvement_4")}
              </li>
              <li>
                {t("aboutpage.improvement_5")}
              </li>
              <li>
                {t("aboutpage.improvement_6")}
              </li>
            </ol>
            <h4>{t("aboutpage.literature_title")}</h4>
            <div>
              {t("aboutpage.literature_discription")}
            </div>
            <p>{t("aboutpage.suggetion_title")}</p>
            <ol className="custom-list">
              <li>
                {t("aboutpage.criticise_first")} (
                <em>
                  {t("aboutpage.criticise_second")}
                </em>
                ),  {t("aboutpage.see")}&nbsp;
                <Link target="_blank" to="https://www.themarginalian.org/2014/03/28/daniel-dennett-rapoport-rules-criticism/">
                  https://www.themarginalian.org/2014/03/28/daniel-dennett-rapoport-rules-criticism/
                </Link>&nbsp;
                ( {t("aboutpage.referring_to")} [2]).
              </li>
              <p className="margin_left_30px">
                {t("aboutpage.suggestion_subtitle")}
              </p>
              <li>
                {t("aboutpage.daniel_dennett_reference")}
              </li>
              <li>
                {t("aboutpage.anatol_rapoport")}
                ( {t("aboutpage.see")}
                <Link to="https://sci-hub.se/10.1287/mnsc.7.3.210">
                  https://sci-hub.se/10.1287/mnsc.7.3.210
                </Link>
                ).
              </li>
              <li>
                <Trans
                  i18nKey="aboutpage.anatol_rapoport3"
                  values={{
                    link: "https://archive.org/details/fightsgamesdebat0000rapo_v5i4/page/284/mode/2up",
                    link2: "https://archive.org/details/fightsgamesdebat0000rapo_v5i4/page/288/mode/2up"
                  }}
                  components={{
                    linktag: <Link target="_blank" to="https://archive.org/details/fightsgamesdebat0000rapo_v5i4/page/284/mode/2up"></Link>,
                    linktag2: <Link target="_blank" to="https://archive.org/details/fightsgamesdebat0000rapo_v5i4/page/288/mode/2up"></Link>,
                  }}
                />
              </li>
              <li>
                <Trans
                  i18nKey="aboutpage.anatol_rapoport4"
                  values={{ link: "https://en.wikipedia.org/wiki/Rogerian_argument" }}
                  components={{
                    linktag: <Link target="_blank" to="https://en.wikipedia.org/wiki/Rogerian_argument">Link</Link>,
                    emtag: <em></em>
                  }}
                />
              </li>
              <p className="margin_left_30px">
                {t("aboutpage.anatol_rapoport4_para")}
              </p>
              <li>
                <Trans
                  i18nKey="aboutpage.rhetoric_discovery_change"
                  values={{
                    link: "https://archive.org/details/rhetoricdiscover0000youn/page/274/mode/2up",
                    link2: "https://archive.org/details/rhetoricdiscover0000youn/page/286/mode/2up"
                  }}
                  components={{
                    linktag: <Link target="_blank" to="https://archive.org/details/rhetoricdiscover0000youn/page/274/mode/2up"></Link>,
                    linktag2: <Link target="_blank" to="https://archive.org/details/rhetoricdiscover0000youn/page/286/mode/2up"></Link>,
                  }}
                />
              </li>
              <p>
                <Trans
                  i18nKey="aboutpage.rhetoric_discovery_change_discription"
                  components={{
                    emtag: <em></em>
                  }}
                />
              </p>
              <p className="">
                {t("aboutpage.what_trying_support")}
              </p>
              <li id="rule7">
                {t("aboutpage.teich_reference")}
              </li>
              <li>
                <Trans
                  i18nKey="aboutpage.rogerian_rhetoric_reference"
                  values={{ link: "https://en.m.wikipedia.org/wiki/ELIZA" }}
                  components={{
                    linktag: <Link target="_blank" to="https://en.m.wikipedia.org/wiki/ELIZA">Link</Link>,
                    emtag: <em></em>
                  }}
                />
              </li>
              <li>
                <Trans
                  i18nKey="aboutpage.rogers_weizenbaum_reference"
                  values={{ link: "https://en.m.wikipedia.org/wiki/ELIZA" }}
                  components={{
                    linktag: <Link target="_blank" to="https://en.m.wikipedia.org/wiki/ELIZA">Link</Link>,
                  }}
                />
              </li>
              <li>
                <Trans
                  i18nKey="aboutpage.ury_reference"
                  values={{ link: "https://archive.org/details/gettingtopeacetr0000uryw/page/148/mode/2up" }}
                  components={{
                    linktag: <Link target="_blank" to="https://archive.org/details/gettingtopeacetr0000uryw/page/148/mode/2up">Link</Link>,
                  }}
                />
              </li>
              <p>
                <Trans
                  i18nKey="aboutpage.middle_ages_rule"
                  components={{
                    emtag: <em></em>
                  }}
                />
              </p>
              <p>
                <Trans
                  i18nKey="aboutpage.ury_statement"
                  components={{
                    emtag: <em></em>
                  }}
                />
              </p>
              <li>
                <Trans
                  i18nKey="aboutpage.pieper_reference"
                  values={{ link: "https://archive.org/details/guidetothomasaqu0000piep/page/82/mode/2up" }}
                  components={{
                    linktag: <Link target="_blank" to="https://archive.org/details/guidetothomasaqu0000piep/page/82/mode/2up">Link</Link>,
                  }}
                />
              </li>
              <p>
                <Trans
                  i18nKey="aboutpage.disputatio_quote"
                  components={{
                    emtag: <em></em>
                  }}
                />
              </p>
              <p>
                {t("aboutpage.looking_for_source")}
              </p>
              <p>{t("aboutpage.pieper_statement")}</p>
              <p>
                <Trans
                  i18nKey="aboutpage.socrates_practice"
                  components={{
                    emtag: <em></em>
                  }}
                />
              </p>
              <p>
                <Trans
                  i18nKey="aboutpage.socrates_remark"
                  components={{
                    emtag: <em></em>
                  }}
                />
              </p>
              <p>
                <Trans
                  i18nKey="aboutpage.sokrates_phaedo"
                  components={{
                    emtag: <em></em>
                  }}
                />
              </p>
              <li>
                <Trans
                  i18nKey="aboutpage.active_listening"
                  values={{ link: "https://en.wikipedia.org/wiki/Active_listening" }}
                  components={{
                    linktag: <Link target="_blank" to="https://en.wikipedia.org/wiki/Active_listening">Link</Link>,
                  }}
                />
              </li>
              <li>
                <Trans
                  i18nKey="aboutpage.ideological_turing_test"
                  values={{ link: "https://rationalwiki.org/wiki/Ideological_Turing_test" }}
                  components={{
                    linktag: <Link target="_blank" to="https://rationalwiki.org/wiki/Ideological_Turing_test">Link</Link>,
                  }}
                />
              </li>
              <li>
                <Trans
                  i18nKey="aboutpage.steel_man_argument"
                  values={{ link: "https://en.wikipedia.org/wiki/Straw_man#Steelmanning" }}
                  components={{
                    linktag: <Link target="_blank" to="https://en.wikipedia.org/wiki/Straw_man#Steelmanning">Link</Link>,
                  }}
                />
              </li>
              <li>
                <Trans
                  i18nKey="aboutpage.dialectical_principle"
                  values={{ link: "https://doi.org/10.1007/s10503-023-09615-8" }}
                  components={{
                    linktag: <Link target="_blank" to="https://doi.org/10.1007/s10503-023-09615-8">Link</Link>,
                    emtag: <em></em>,
                    strongtag: <strong></strong>
                  }}
                />
              </li>
              <li>
                <Trans
                  i18nKey="aboutpage.role_reversal"
                  values={{ link: "https://www.jstor.org/stable/172670" }}
                  components={{ linktag: <Link target="_blank" to="https://www.jstor.org/stable/172670">Link</Link>, }}
                />
              </li>
              <li>
                <Trans
                  i18nKey="aboutpage.hearing_statement"
                  values={{ link: "https://www.independent.co.uk/voices/i-hear-what-you-re-saying-but-i-ll-ignore-it-1357551.html" }}
                  components={{
                    linktag: <Link target="_blank" to="https://www.independent.co.uk/voices/i-hear-what-you-re-saying-but-i-ll-ignore-it-1357551.html">Link</Link>,
                    emtag: <em></em>
                  }}
                />
              </li>
            </ol>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default AboutUs;
